// Mock Product Data for Vesta Workwear E-commerce

export const products = [
  {
    id: 'vesta-apex-suit-001',
    name: 'Vesta Apex Spray Suit',
    slug: 'vesta-apex-spray-suit',
    tagline: 'Professional-grade spray suit engineered for women',
    price: 159.00,
    currency: 'AUD',
    category: 'refinishing-suits',
    collection: 'core',
    inStock: true,
    featured: true,
    images: [
      'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/160126_VestaWorkwear-73.jpg?v=1772281308',
      'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/160126_VestaWorkwear-19.jpg?v=1772281308',
      'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/160126_VestaWorkwear-69.jpg?v=1772281308',
      'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/160126_VestaWorkwear-15.jpg?v=1772281308',
      'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/160126_VestaWorkwear-09.jpg?v=1772281309',
    ],
    colors: [
      { name: 'Grey / Teal', split: true, hex: '#545759', hex2: '#004D51', available: true }
    ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'],
    sizeGuideLink: '/fit',
    shortDescription: 'Professional refinishing suit designed specifically for women. Patent pending design with no excess fabric, full range of motion, static-dissipative, paint-safe.',
    features: [
      {
        icon: 'target',
        title: 'Women\'s-Specific Fit',
        description: 'Tailored for women\'s proportions with no excess fabric around hips, waist, or seat'
      },
      {
        icon: 'shield',
        title: 'Static-Dissipative',
        description: 'Carbon fiber threading helps dissipate static for safe spray booth use'
      },
      {
        icon: 'activity',
        title: 'Full Range of Motion',
        description: 'Articulated knees and patent pending articulated rear panel for kneeling, squatting, and reaching'
      },
      {
        icon: 'droplet',
        title: 'Paint-Safe Design',
        description: 'Low-lint fabric and secure closures prevent contamination in the booth'
      },
      {
        icon: 'move',
        title: 'Full Range of Motion',
        description: 'Squat, bend, and reach without pulling or splitting seams - articulated design for every workshop task'
      },
      {
        icon: 'package',
        title: 'Side Zipper Access',
        description: 'Access clothing, pockets, and phone underneath without removing the entire suit'
      }
    ],
    detailedDescription: `
      The Vesta Apex Spray Suit (Patent Pending) was designed in collaboration with female spray painters and apprentices 
      in Australian collision repair shops. Together, we created a suit that:
      
      - Actually fits women's bodies (not just scaled-down men's patterns)
      - Moves with you through every workshop task - squat, bend, reach without restriction
      - Protects your work from lint and contamination
      - Built with premium materials for wash-and-reuse, not disposable wear
      - Looks professional and feels empowering
      
      This isn't compromise. This is what you deserve.
    `,
    specifications: {
      fabric: 'Premium weight polyester with carbon fiber thread',
      closure: 'Full-length front zipper',
      sideZippers: 'Two-way side zippers for access to clothing underneath',
      pockets: '2 deep rear pockets',
      washing: 'Machine washable - wash in Vesta Wash Bag or inside out to protect Velcro closures. Do not tumble dry.',
      madeIn: 'Designed in Australia, manufactured ethically overseas'
    },
    fitNotes: [
      'True to size - order your normal size',
      'Designed to be worn over light clothing',
      'If between sizes, size up for layering',
      'Petite? Check our fit guide for specific recommendations'
    ],
    care: [
      'Machine wash warm, inside out',
      'Wash in Vesta Wash Bag or inside out to protect Velcro',
      'Do not tumble dry - hang to dry only',
      'Do not bleach or iron',
      'Close all zippers before washing',
      'Repairs available - contact us for patch kits'
    ],
    reviews: {
      average: 0,
      count: 0,
      featured: []
    },
    crossSells: ['wash-bag-001', 'aluminium-mixing-rulers-001'],
    upgradeBundle: {
      slug: 'vesta-apex-spray-suit-rotation-pack',
      title: 'Upgrade to the Rotation Pack',
      description: 'Get 2 suits + a Wash Bag + FREE shipping — bonus gear and better value.',
      cta: 'View Rotation Pack'
    }
  },
  {
    id: 'rotation-pack-001',
    name: 'Vesta Apex Spray Suit Rotation Pack',
    slug: 'vesta-apex-spray-suit-rotation-pack',
    tagline: '2 Suits + Wash Bag + FREE Shipping',
    price: 325.00,
    currency: 'AUD',
    category: 'bundles',
    collection: 'bundles',
    inStock: true,
    featured: true,
    freeShipping: true,
    images: [
      'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/160126_VestaWorkwear-71.jpg?v=1772281721',
      'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/160126_VestaWorkwear-73_2bbbefaf-270c-4648-abfb-30283ffda87a.jpg?v=1772281721',
      'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/160126_VestaWorkwear-70.jpg?v=1772281721',
    ],
    colors: null,
    sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'],
    shortDescription: '2 x SUITS + 1 x WASH BAG + FREE SHIPPING! The Vesta Apex Spray Suit Rotation Pack includes two premium quality spray suits and a dedicated wash bag, perfect for maintaining continuous workwear availability.',
    features: [
      {
        icon: 'package',
        title: '2 Suits Included',
        description: 'Rotate between washes - always have a clean suit ready'
      },
      {
        icon: 'gift',
        title: 'Wash Bag Included',
        description: 'Protect your suits during washing'
      },
      {
        icon: 'truck',
        title: 'Free Shipping',
        description: 'No shipping costs on this bundle'
      },
      {
        icon: 'percent',
        title: 'Save $46.90',
        description: 'Better value than buying separately'
      }
    ],
    detailedDescription: `
      The Rotation Pack is designed for professional refinishers who work daily and need a fresh suit ready to go.
      
      What's included:
      - 2x Vesta Apex Spray Suits (choose your size)
      - 1x Vesta Wash Bag
      - FREE shipping Australia-wide
      
      Why rotate?
      - Always have a clean suit ready while one is in the wash
      - Extend the life of both suits by reducing wash frequency
      - Professional appearance every day
      
      Wear one suit while the other is being laundered, ensuring you always have a clean, ready-to-wear option.
    `,
    bundleContents: [
      { productId: 'vesta-apex-suit-001', quantity: 2 },
      { productId: 'wash-bag-001', quantity: 1 }
    ],
    savings: 46.90
  },
  {
    id: 'wash-bag-001',
    name: 'Vesta Wash Bag',
    slug: 'vesta-wash-bag',
    tagline: 'Protect your suit during washing',
    price: 12.95,
    currency: 'AUD',
    category: 'accessories',
    collection: 'care',
    inStock: true,
    featured: false,
    images: ['https://cdn.shopify.com/s/files/1/0770/5572/1703/files/IMG_0406.jpg?v=1782438256'],
    colors: null,
    sizes: ['One Size'],
    shortDescription: 'Protect your Vesta Apex Spray Suit with this purpose-designed wash bag. Simply place your suit inside and machine wash with confidence.',
    features: [
      {
        icon: 'shield',
        title: 'Protective Mesh',
        description: 'Shields your suit from damage while allowing thorough cleaning'
      },
      {
        icon: 'refresh-cw',
        title: 'Extends Suit Life',
        description: 'Keep your workwear in top condition'
      }
    ],
    care: [
      'Machine wash on a cool, gentle cycle',
      'Air dry - do not tumble dry',
      'Do not bleach or iron',
      'Zip closed before washing to protect the mesh'
    ]
  },
  {
    id: 'aluminium-mixing-rulers-001',
    name: '2:1/1:1 Aluminium Paint Mixing Stick - Pk 2',
    slug: '2-1-1-1-aluminium-paint-mixing-stick-pk-2',
    tagline: 'Dual-sided 2:1 & 1:1 ratio mixing rulers — Pack of 2',
    price: 14.95,
    currency: 'AUD',
    category: 'accessories',
    collection: 'care',
    inStock: true,
    featured: false,
    images: [
      'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/IMG_0383.jpg?v=1782458419',
      'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/IMG_0396.jpg?v=1782458419',
      'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/IMG_0391.jpg?v=1782458419',
    ],
    colors: null,
    sizes: ['One Size'],
    shortDescription: 'Aluminium Paint Mixing Rulers, dual sided 2:1 & 1:1 ratio — great for 1K Met/Pearl & 2K. 200mm. Pack of 2.',
    features: [
      {
        icon: 'target',
        title: 'Dual-Sided Ratios',
        description: '2:1 on one side, 1:1 on the other — perfect for 1K Met/Pearl & 2K mixing'
      },
      {
        icon: 'shield',
        title: 'Durable Aluminium',
        description: 'Hard-wearing 200mm aluminium rulers built for daily booth use'
      },
      {
        icon: 'package',
        title: 'Pack of 2',
        description: 'Two rulers per pack so you always have a spare on the bench'
      }
    ],
    detailedDescription: `
      Aluminium Paint Mixing Rulers, dual sided 2:1 & 1:1 ratio — great for 1K Met/Pearl & 2K.

      - 200mm aluminium rulers
      - Dual-sided: 2:1 and 1:1 mixing ratios
      - Ideal for 1K Metallic/Pearl and 2K mixing
      - Pack of 2
    `
  }
];

export const collections = [
  {
    id: 'refinishing-suits',
    name: 'Spray Suits',
    slug: 'refinishing-suits',
    description: 'Professional-grade suits engineered for women',
    image: 'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/160126_VestaWorkwear-73.jpg?v=1772281308',
    featured: true
  },
  {
    id: 'bundles',
    name: 'Value Bundles',
    slug: 'bundles',
    description: 'Save with our curated bundles',
    image: 'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/160126_VestaWorkwear-71.jpg?v=1772281721',
    featured: true
  },
  {
    id: 'accessories',
    name: 'Accessories & Care',
    slug: 'accessories',
    description: 'Everything to keep your gear performing',
    image: 'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/IMG_0406.jpg?v=1782438256',
    featured: true
  },
  {
    id: 'limited-editions',
    name: 'Limited Editions',
    slug: 'limited-editions',
    description: 'Special colorways and collaborations',
    image: 'https://cdn.shopify.com/s/files/1/0770/5572/1703/files/160126_VestaWorkwear-19.jpg?v=1772281308',
    featured: false,
    comingSoon: true
  }
];

export const sizeChart = {
  measurements: {
    headers: {
      cm: ['Size', 'Bust (cm)', 'Waist (cm)', 'Hip (cm)', 'Height (cm)'],
      inches: ['Size', 'Bust (in)', 'Waist (in)', 'Hip (in)', 'Height (in)']
    },
    rows: {
      cm: [
        ['XS', '81-86', '63-68', '86-91', '155-165'],
        ['S', '86-91', '68-73', '91-96', '160-170'],
        ['M', '91-96', '73-78', '96-101', '165-175'],
        ['L', '96-104', '78-86', '101-109', '170-180'],
        ['XL', '104-112', '86-94', '109-117', '175-185'],
        ['2XL', '112-120', '94-102', '117-125', '175-185']
      ],
      inches: [
        ['XS', '32-34', '25-27', '34-36', '61-65'],
        ['S', '34-36', '27-29', '36-38', '63-67'],
        ['M', '36-38', '29-31', '38-40', '65-69'],
        ['L', '38-41', '31-34', '40-43', '67-71'],
        ['XL', '41-44', '34-37', '43-46', '69-73'],
        ['2XL', '44-47', '37-40', '46-49', '69-73']
      ]
    }
  },
  howToMeasure: [
    {
      measurement: 'Bust',
      instruction: 'Measure around the fullest part of your bust, keeping the tape parallel to the floor'
    },
    {
      measurement: 'Waist',
      instruction: 'Measure around your natural waistline, keeping the tape comfortably loose'
    },
    {
      measurement: 'Hip',
      instruction: 'Measure around the fullest part of your hips, about 20cm below your waist'
    },
    {
      measurement: 'Height',
      instruction: 'Stand straight against a wall and measure from floor to top of head'
    }
  ],
  fitAdvice: [
    'The suit is designed to fit over light clothing (t-shirt and pants)',
    'If between sizes, we recommend sizing up',
    'Petite? Consider going down a size and checking inseam length',
    'Tall? The suit has adjustable cuffs and can accommodate longer limbs'
  ]
};

// Helper functions
export const getProductById = (id) => products.find(p => p.id === id);
export const getProductBySlug = (slug) => products.find(p => p.slug === slug);
export const getProductsByCategory = (category) => products.filter(p => p.category === category);
export const getFeaturedProducts = () => products.filter(p => p.featured);
export const getCollectionBySlug = (slug) => collections.find(c => c.slug === slug);
